import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { SimulationTask, SimulationTaskStatus } from '@services';
import { Grid, IconButton, Stack, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { LightCardWithTitle } from '@components/common';

const KPI: FC<{ value: ReactNode; description: ReactNode; border?: boolean }> = ({ value, description, border }) => {
	return (
		<Grid
			item
			xs={4}
			sx={{
				flexGrow: 1,
				borderBottomWidth: border ? 1 : 0,
				borderBottomStyle: border ? 'solid' : 'none',
				borderBottomColor: 'grey.100'
			}}
		>
			<Stack
				direction="column"
				spacing={0.5}
				sx={{
					paddingY: 2
				}}
			>
				<Typography variant="h4">{value}</Typography>
				<Typography variant="body2" sx={{ maxWidth: 180 }}>
					{description}
				</Typography>
			</Stack>
		</Grid>
	);
};

export interface IExecuteSummaryVehicleProps {
	tasks?: SimulationTask[];
}

export const ExecuteSummaryVehicle: FC<IExecuteSummaryVehicleProps> = ({ tasks }) => {
	const navigate = useNavigate();
	const fulfilledVehicles = (tasks || []).filter((task) => task.status === SimulationTaskStatus.FULFILLED);
	const erroredVehicles = (tasks || []).filter((task) => task.status === SimulationTaskStatus.ERROR);
	const dataMissingVehicles = (tasks || []).filter((task) => task.status === SimulationTaskStatus.NOT_FULFILLED);

	return (
		<LightCardWithTitle
			headerVariant="dark"
			title={<Tr.Portal path="dashboard.vehicles" />}
			actionButton={
				<Stack
					direction="row"
					alignItems="center"
					spacing={1}
					onClick={() => navigate(`/portal/${PortalRoutePath.DASHBOARD}/vehicle-suggestions`)}
				>
					<Typography sx={{ cursor: 'pointer' }}>
						<Tr.Portal path="dashboard.executive-summary-vehicles.more-details" />
					</Typography>
					<IconButton size="small" sx={{ color: 'inherit' }}>
						<ArrowForwardIcon color="inherit" />
					</IconButton>
				</Stack>
			}
		>
			<Grid container>
				<KPI
					value={tasks?.length || 0}
					description={<Tr.Portal path="dashboard.executive-summary-vehicles.total-vehicles" />}
					border
				/>
				<KPI
					value={fulfilledVehicles?.length || 0}
					description={<Tr.Portal path="dashboard.executive-summary-vehicles.total-bev-vehicles" />}
					border
				/>
				<KPI value={0} description={<Tr.Portal path="dashboard.executive-summary-vehicles.total-phev-vehicles" />} border />
				<KPI
					value={erroredVehicles?.length || 0}
					description={<Tr.Portal path="dashboard.executive-summary-vehicles.total-error-vehicles" />}
				/>
				<KPI
					value={dataMissingVehicles?.length || 0}
					description={<Tr.Portal path="dashboard.executive-summary-vehicles.total-missing-data-vehicles" />}
				/>
			</Grid>
		</LightCardWithTitle>
	);
};
